import { getDistanceAndRotateBetweenPoints } from 'containers/Playground/utils/playground'
import { selectPlaygroundFrame } from '../playgroundSlice'
import { useReduxSelector } from 'store'
import FrameLine from './FrameLine'
import React from 'react'

interface PlaceFrameProps {
  borderPoints: boolean
  showBorderPoints: basic.BasicFunc
}

const PlaceFrame: React.FC<PlaceFrameProps> = ({ borderPoints, showBorderPoints }) => {
  const place = useReduxSelector(selectPlaygroundFrame)
  const listRef = React.useRef(null)

  const dbClickAction = (e: React.MouseEvent) => {
    if (!borderPoints) {
      e.stopPropagation()
      showBorderPoints()
    }
  }

  return (
    <div ref={listRef}>
      {place.length > 0 && place.map((position, idx, arr) => {
        const next = arr[idx + 1] || arr[0]
        const previous = arr[idx - 1] || arr[arr.length - 1]
        const features = getDistanceAndRotateBetweenPoints(position, next)

        return <FrameLine
          {...features}
          key={idx}
          idx={idx}
          next={next}
          listRef={listRef}
          previous={previous}
          position={position}
          borderPoints={borderPoints}
          dbClickAction={dbClickAction} />
      })}
    </div>
  )
}

export default PlaceFrame